
import { Component, Vue } from 'vue-property-decorator'
import { getMerchantsGroupList, GetOrganizationInfoAll } from '@/api/customerManage'
import { Getter } from 'vuex-class'
import AreaPopup from '@/views/dataReport/template/AddrPopup.vue'

@Component({
  components: {AreaPopup}
})
export default class AreaMoreFilter extends Vue {
  params = {
    deptId: '', //部门id
    orderType: '1', // 查看方式
    statisticType: 'area', // 统计方式
    areaName: '全部区域', //地区名称
    areaId: '', //读取id
    sortType: '1', // 排序方式
    type: '1', // 商品类型
    levelIds: '' //部门级别编号
  }

  orderTypeOptions = [
    {text: '按订单查看', value: '1'},
    {text: '按商品查看', value: '2'}
  ]

  statisticOptions = [
    {text: '按区域统计', value: 'area'},
    {text: '按部门统计', value: 'dept'}
  ]

  get sortTypeOptions(){
   const  sortTypeOptions1 = [
      {text: '订货单数量排行', value: '1'},
      {text: '退货单数量排行', value: '2'},
      {text: '订货金额排行', value: '3'},
      {text: '退货金额排行', value: '4'},
      {text: '退款金额排行', value: '5'}
    ]

   const sortTypeOption2 = [
      {text: '订货单数量排行', value: '1'},
      {text: '退货单数量排行', value: '2'},
      {text: '订货金额排行', value: '3'},
      {text: '退货金额排行', value: '4'}
    ]
    console.log(this.params.orderType)
    return this.params.orderType === '1' ? sortTypeOptions1 : sortTypeOption2
  }



  goodsTypeOptions = [
    {text: '按商品名称统计', value: '1'},
    {text: '按商品品牌统计', value: '2'},
    {text: '按商品分类统计', value: '3'}
  ]

  groupList = [{
    orgId: '',
    orgName: '全部分组'
  }]

  depList = []

  created () {
    this.getDepList()
    let query = this.$route.query as any
    this.params = {...query}
  }

  /**
   * 获取客户分组列表
   */
  getDepList () {
    GetOrganizationInfoAll({}).then((res: any) => {
      this.depList = res.data
      this.depList.forEach(item => {
        if (item.isEnabled === '0' || item.orgType === '1') {
          item.disabled = true
        }
      })
      this.params.deptId=this.depList[0].orderId
    })
  }

  /**
   * @description: 查看方式选择事件
   */
  handleOrderTypeOptions (type) {
    this.params.orderType = type
  }

  /**
   * @description: 地区选择弹框打开
   */
  handleAreaChoose () {
    (this.$refs.areaPopup as AreaPopup).showPop()
  }

  /**
   * @description: 统计方式方式选择事件
   */
  handleStatisticOptions (type) {
    this.params.statisticType = type
  }

  /**
   * @description: 商品排行方式选择事件
   */
  handleGoodsTypeOptions (type) {
    this.params.type = type
  }


  /**
   * @description: 客户分组选择事件
   */
  handleGroupOptions (type, levelIds) {
    this.params.deptId = type
    this.params.levelIds = levelIds
  }

  /**
   * @description: 排序方式选择事件
   */
  handleSortTypeOptions (type) {
    this.params.sortType = type
  }

  /**
   * 区域选择改变
   * @param addressId
   * @param addressName
   * @param index
   */
  handleAddressChange ({addressId, addressName}) {
    this.params.areaId = addressId
    this.params.areaName = addressName
  }

  /**
   * 取消
   */
  cancel () {
    this.$router.back()
  }

  /**
   * 重置
   */
  resetFunc () {
    this.params.orderType = '1'
    this.params.statisticType = 'area'
    this.params.deptId = ''
    this.params.type = '1'
    this.params.sortType = '1'
  }

  /**
   * 确认
   */
  confirm () {
    this.$router.back()
    this.$eventBus.$emit('areaMoreFilter', this.params)
  }
}
